var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFame2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 133,
    viewBox: "0 0 149 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.278 17.8844C116.412 28.6362 106 0 106 0C106 0 95.5875 28.6362 65.7223 17.8844C65.7223 17.8844 47.3629 79.4809 106 110.571C164.637 79.4809 146.278 17.8844 146.278 17.8844Z",
    fill: "url(#paint0_linear_222_10938)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.996 110.567C132.231 96.6561 143.051 76.6417 147.001 58.7686H64.9908C68.9417 76.6417 79.7613 96.6599 105.996 110.567Z",
    fill: "url(#paint1_linear_222_10938)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.278 17.8844C116.412 28.6362 106 0 106 0V110.571C164.637 79.4809 146.278 17.8844 146.278 17.8844Z",
    fill: "url(#paint2_linear_222_10938)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.711 109.636C107.998 109.478 108.281 109.32 108.56 109.161C108.722 109.067 108.884 108.973 109.046 108.882C109.299 108.735 109.551 108.592 109.804 108.445C109.973 108.347 110.143 108.245 110.313 108.143C110.554 108 110.791 107.857 111.029 107.714C111.199 107.612 111.368 107.506 111.534 107.404C111.768 107.261 112.002 107.114 112.232 106.971C112.397 106.869 112.559 106.764 112.725 106.662C112.959 106.515 113.189 106.364 113.423 106.213C113.577 106.111 113.736 106.01 113.89 105.908C114.132 105.749 114.369 105.591 114.607 105.433C114.746 105.339 114.889 105.244 115.029 105.15C115.308 104.962 115.583 104.769 115.858 104.581C115.952 104.517 116.047 104.449 116.141 104.385C116.507 104.128 116.869 103.872 117.227 103.612C117.317 103.544 117.408 103.476 117.502 103.412C117.766 103.22 118.03 103.024 118.294 102.832C118.425 102.734 118.557 102.632 118.689 102.534C118.908 102.372 119.123 102.206 119.338 102.04C119.481 101.931 119.621 101.821 119.76 101.712C119.96 101.554 120.16 101.399 120.359 101.241C120.503 101.128 120.646 101.011 120.785 100.898C120.978 100.743 121.17 100.588 121.358 100.434C121.502 100.317 121.641 100.2 121.781 100.083C121.969 99.9287 122.154 99.7704 122.339 99.612C122.474 99.4952 122.614 99.3783 122.75 99.2614C122.938 99.0993 123.123 98.9372 123.308 98.7751C123.436 98.662 123.568 98.5489 123.696 98.4358C123.892 98.2624 124.088 98.0853 124.28 97.9118C124.393 97.8101 124.506 97.712 124.616 97.6102C124.88 97.369 125.143 97.1239 125.404 96.8789C125.471 96.8186 125.536 96.7545 125.6 96.6941C125.863 96.4453 126.124 96.1965 126.38 95.9477C126.489 95.8422 126.599 95.7328 126.704 95.6273C126.881 95.4539 127.059 95.2767 127.236 95.1033C127.356 94.9826 127.477 94.8582 127.598 94.7376C127.756 94.5755 127.914 94.4171 128.069 94.255C128.193 94.1269 128.318 93.9987 128.438 93.8705C128.589 93.7122 128.736 93.5576 128.883 93.3993C129.008 93.2673 129.128 93.1354 129.253 93.0034C129.396 92.8489 129.539 92.6905 129.679 92.536C129.799 92.404 129.92 92.2683 130.041 92.1363C130.18 91.9818 130.32 91.8234 130.455 91.6651C130.572 91.5332 130.689 91.3974 130.806 91.2655C130.945 91.1034 131.081 90.945 131.221 90.7829C131.334 90.651 131.443 90.5228 131.552 90.3909C131.699 90.2175 131.843 90.044 131.986 89.8669C132.084 89.75 132.182 89.6293 132.28 89.5125C132.51 89.2297 132.736 88.947 132.962 88.6605C133.06 88.5323 133.158 88.4079 133.256 88.2797C133.388 88.1138 133.516 87.9442 133.645 87.7783C133.754 87.6351 133.859 87.4918 133.969 87.3486C134.082 87.1978 134.199 87.0432 134.312 86.8924C134.421 86.7454 134.53 86.5946 134.64 86.4475C134.749 86.3005 134.855 86.1535 134.96 86.0027C135.07 85.8519 135.179 85.6973 135.284 85.5465C135.386 85.4033 135.488 85.2563 135.59 85.113C135.699 84.9584 135.805 84.8039 135.91 84.6493C136.008 84.506 136.103 84.3628 136.201 84.2195C136.306 84.0612 136.412 83.9029 136.517 83.7445C136.611 83.605 136.702 83.4656 136.792 83.3261C136.898 83.164 137.004 83.0056 137.105 82.8435C137.192 82.7078 137.275 82.5721 137.362 82.4401C137.467 82.2743 137.573 82.1084 137.675 81.9425C137.742 81.8332 137.81 81.7201 137.878 81.6108C138.112 81.23 138.338 80.853 138.561 80.4723C138.613 80.3818 138.67 80.2875 138.723 80.197C138.828 80.0123 138.934 79.8314 139.036 79.6466C139.103 79.5298 139.171 79.4091 139.235 79.2923C139.337 79.1113 139.435 78.9304 139.533 78.7532C139.601 78.6325 139.665 78.5119 139.733 78.3913C139.831 78.2103 139.925 78.0331 140.023 77.8522C140.087 77.7315 140.151 77.6071 140.216 77.4865C140.31 77.3055 140.404 77.1246 140.498 76.9436C140.559 76.823 140.619 76.7061 140.679 76.5855C140.773 76.4008 140.864 76.216 140.958 76.0313C141.015 75.9182 141.071 75.8051 141.124 75.692C141.218 75.4998 141.309 75.3113 141.403 75.119C141.452 75.0172 141.497 74.9192 141.546 74.8174C141.644 74.6138 141.739 74.4102 141.833 74.2029C141.859 74.1426 141.886 74.0823 141.916 74.022C142.274 73.2378 142.617 72.4574 142.941 71.6733C142.956 71.6394 142.968 71.6092 142.983 71.5753C143.077 71.3491 143.167 71.1229 143.262 70.8929C143.292 70.8175 143.322 70.7459 143.352 70.6705C143.439 70.4556 143.522 70.2407 143.605 70.0258C143.639 69.9391 143.673 69.8562 143.703 69.7695C143.786 69.5584 143.865 69.3473 143.944 69.1361C143.978 69.0494 144.008 68.9627 144.042 68.876C144.121 68.6611 144.2 68.45 144.276 68.2351C144.306 68.156 144.332 68.0768 144.362 67.9939C144.442 67.7714 144.517 67.5528 144.596 67.3304C144.619 67.2663 144.641 67.2022 144.664 67.1343C144.743 66.8968 144.826 66.6631 144.901 66.4256C144.909 66.3992 144.917 66.3766 144.924 66.3502C145.38 64.9666 145.791 63.5868 146.157 62.2146C146.164 62.1807 146.176 62.143 146.187 62.109C146.251 61.864 146.315 61.619 146.379 61.3739C146.391 61.3287 146.402 61.2797 146.413 61.2344C146.474 60.9931 146.534 60.7519 146.594 60.5106C146.605 60.4654 146.617 60.4201 146.628 60.3749C146.688 60.1298 146.745 59.8848 146.802 59.6398C146.809 59.6058 146.817 59.5719 146.824 59.538C146.884 59.2816 146.941 59.0215 146.998 58.7651H105.992V110.564C106.43 110.334 106.859 110.1 107.285 109.866C107.425 109.787 107.564 109.712 107.708 109.632L107.711 109.636Z",
    fill: "url(#paint3_linear_222_10938)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.996 77.4305C116.302 77.4305 124.657 69.0756 124.657 58.7694C124.657 48.4632 116.302 40.1084 105.996 40.1084C95.6899 40.1084 87.3351 48.4632 87.3351 58.7694C87.3351 69.0756 95.6899 77.4305 105.996 77.4305Z",
    fill: "url(#paint4_linear_222_10938)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.996 74.4448C114.653 74.4448 121.671 67.4267 121.671 58.7695C121.671 50.1123 114.653 43.0942 105.996 43.0942C97.3388 43.0942 90.3208 50.1123 90.3208 58.7695C90.3208 67.4267 97.3388 74.4448 105.996 74.4448Z",
    fill: "#4671F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.71 66.6223C101.359 66.6223 101.02 66.4828 100.771 66.234L96.2848 61.7478C95.7683 61.2313 95.7683 60.3907 96.2848 59.8742C96.8013 59.3577 97.642 59.3577 98.1585 59.8742L101.706 63.4217L113.826 51.3014C114.343 50.7849 115.183 50.7849 115.7 51.3014C116.216 51.8179 116.216 52.6586 115.7 53.1751L102.641 66.234C102.392 66.4828 102.057 66.6223 101.702 66.6223H101.71Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.562 86.481H2.49503C1.11706 86.481 0 87.598 0 88.976V130.373C0 131.751 1.11706 132.868 2.49503 132.868H48.562C49.94 132.868 51.0571 131.751 51.0571 130.373V88.976C51.0571 87.598 49.94 86.481 48.562 86.481Z",
    fill: "url(#paint5_linear_222_10938)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.562 86.481H43.7352C45.1134 86.481 46.2303 87.5979 46.2303 88.976V130.37C46.2303 131.748 45.1134 132.865 43.7352 132.865H48.562C49.9402 132.865 51.0571 131.748 51.0571 130.37V88.976C51.0571 87.5979 49.9402 86.481 48.562 86.481Z",
    fill: "#6A8BF2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49835 86.481H7.32517C5.94701 86.481 4.83012 87.5979 4.83012 88.976V130.37C4.83012 131.748 5.94701 132.865 7.32517 132.865H2.49835C1.12019 132.865 0.0032959 131.748 0.0032959 130.37V88.976C0.0032959 87.5979 1.12019 86.481 2.49835 86.481Z",
    fill: "#6A8BF2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.246 86.4817H7.99133V76.7302C7.99133 67.0537 15.7508 59.0558 25.4273 59.0003C35.1462 58.9448 43.069 66.8349 43.069 76.5375V79.0195C43.069 80.4695 41.8933 81.6484 40.44 81.6484C38.99 81.6484 37.8111 80.4727 37.8111 79.0195V76.6942C37.8111 69.9308 32.4128 64.3202 25.6493 64.2549C18.8206 64.1896 13.246 69.7251 13.246 76.5375V86.4817Z",
    fill: "url(#paint6_linear_222_10938)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6487 59.0364C26.2437 59.0103 25.8388 58.9972 25.4273 59.0005C15.7508 59.056 7.99133 67.0539 7.99133 76.7304V86.482H10.2251V76.7304C10.2251 67.3935 17.449 59.621 26.6487 59.0364Z",
    fill: "#CACAC8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4274 59.0003C25.1367 59.0003 24.8526 59.0101 24.5652 59.0264C33.7943 59.5228 41.1521 67.1876 41.1521 76.5375V79.0195C41.1521 80.1331 40.4597 81.0802 39.4832 81.4655C39.7804 81.5831 40.1037 81.6484 40.4401 81.6484C41.8901 81.6484 43.0691 80.4727 43.0691 79.0195V76.5375C43.0691 66.8316 35.1463 58.9448 25.4274 59.0003Z",
    fill: "#E1E0DF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8942 119.593L28.2033 108.329C29.7643 107.412 30.8159 105.713 30.8159 103.77C30.8159 100.851 28.4482 98.4829 25.5286 98.4829C22.609 98.4829 20.2413 100.851 20.2413 103.77C20.2413 105.713 21.2896 107.412 22.8539 108.329L20.1629 119.593C20.0225 120.249 20.5221 120.873 21.1949 120.873H29.8622C30.535 120.873 31.0379 120.253 30.8942 119.593Z",
    fill: "#3069E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91882 120.427H0V117.027H8.91882C9.85936 117.027 10.6203 117.788 10.6203 118.729C10.6203 119.669 9.85936 120.43 8.91882 120.43V120.427Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91882 102.329H0V98.9297H8.91882C9.85936 98.9297 10.6203 99.6906 10.6203 100.631C10.6203 101.572 9.85936 102.333 8.91882 102.333V102.329Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1415 120.427H51.0604V117.027H42.1415C41.201 117.027 40.4401 117.788 40.4401 118.729C40.4401 119.669 41.201 120.43 42.1415 120.43V120.427Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0603 117.027H46.2335V120.427H51.0603V117.027Z",
    fill: "#E2E1E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1415 102.329H51.0604V98.9297H42.1415C41.201 98.9297 40.4401 99.6906 40.4401 100.631C40.4401 101.572 41.201 102.333 42.1415 102.333V102.329Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0603 98.9277H46.2335V102.327H51.0603V98.9277Z",
    fill: "#E2E1E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_10938",
    x1: -10.2959,
    y1: 17.0268,
    x2: 130.184,
    y2: 74.8191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679016,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933198,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_10938",
    x1: -4.90494,
    y1: 66.745,
    x2: 87.1629,
    y2: 143.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679016,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933198,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_10938",
    x1: 69.352,
    y1: 17.0268,
    x2: 148.146,
    y2: 33.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679016,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933198,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_10938",
    x1: 59.0548,
    y1: 99.7138,
    x2: 156.864,
    y2: 99.1506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679016,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_222_10938",
    x1: 107.956,
    y1: 74.8193,
    x2: 107.342,
    y2: 31.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703836,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_222_10938",
    x1: 0.00000191366,
    y1: 151.118,
    x2: 59.1133,
    y2: 60.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228522,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_222_10938",
    x1: 8.06035,
    y1: 108.514,
    x2: 65.7181,
    y2: 109.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126489,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649935,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933198,
    stopColor: "#FCFBFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFame2);
export default __webpack_public_path__ + "static/media/fame-2.530b00d2ae9ff5a232709a942b2294b4.svg";
export { ForwardRef as ReactComponent };